import { shallowRef } from 'vue';
import { resolveBrandProfile } from './brands/registry.js';

export const activeBrand = shallowRef(resolveBrandProfile('autoflow'));
// Customer-facing output keeps its branding independently of the staff UI.
export const customerBrand = shallowRef(resolveBrandProfile('autoflow'));
export function selectBrand(application, requested) {
  const profile = resolveBrandProfile(application, requested);
  return applyBrandProfile(profile);
}

export function applyBrandProfile(profile) {
  activeBrand.value = profile;
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.uiTheme = profile.id;
    let fontLink = document.getElementById('brand-font-stylesheet');
    if (profile.fontStylesheet) {
      if (!fontLink) {
        fontLink = document.createElement('link');
        fontLink.id = 'brand-font-stylesheet';
        fontLink.rel = 'stylesheet';
        document.head.appendChild(fontLink);
      }
      fontLink.href = profile.fontStylesheet;
    } else fontLink?.remove();
  }
  return profile;
}
